export default __webpack_public_path__ + "static/media/link_to_app_image.d9f71aae.jpg";